import config from '../../App/config';

export const findRegionApp = (region) => {
  const regionApps = config.regionApps;
  return regionApps[region];
};
